import React, { useState, useRef } from "react";
import { useGLTF } from "@react-three/drei";
import { Text, Billboard } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";

const Planet = ({
  modelPath,
  position,
  scale,
  onClick,
  section,
  name,
  rotationSpeed = 0.01,
  axialTilt = 0.1,
  frozen = false,
}) => {
  const { scene } = useGLTF(modelPath);
  const [hovered, setHovered] = useState(false);
  const meshRef = useRef();

  useFrame((_, delta) => {
    if (meshRef.current && !frozen) {
      meshRef.current.rotation.y += rotationSpeed * delta;
    }
  });

  return (
    <group
      position={position}
      scale={scale}
      rotation={[0, 0, axialTilt]}
      onPointerOver={() => setHovered(true)}
      onPointerOut={() => setHovered(false)}
      onClick={onClick}
    >
      <group ref={meshRef}>
        <primitive object={scene} />
      </group>

      {/* Name label — used for the Sun only; orbiting planets get labels
          from the static OrbitWithLabel component in Galaxy.js */}
      {name && (
        <Billboard>
          <Text
            position={[0, 8, 0]}
            fontSize={2.2}
            color="#FFB3D9"
            anchorX="center"
            anchorY="middle"
            letterSpacing={0.09}
            fillOpacity={hovered ? 1.0 : 0}
            outlineWidth={0.14}
            outlineColor="#050508"
            outlineOpacity={hovered ? 0.85 : 0}
          >
            {name.toUpperCase()}
          </Text>
        </Billboard>
      )}

      {/* Invisible click-magnet sphere — catches clicks slightly off-center */}
      <mesh onClick={onClick} onPointerOver={() => setHovered(true)} onPointerOut={() => setHovered(false)}>
        <sphereGeometry args={[3.5, 8, 8]} />
        <meshBasicMaterial transparent opacity={0} depthWrite={false} />
      </mesh>
    </group>
  );
};

export default Planet;
